import { isEmpty, reject, compact, map } from 'lodash';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import { FilterType } from './Filter.enum';
import type { IFilter } from './Filter.interface';
import FilterItem from './FilterItem';

export default class Filter extends Root implements IFilter {
  name: string;
  type: FilterType;
  items: Array<FilterItem>;
  isEnterprise: boolean;
  isShared: boolean;

  getName() {
    return this.name;
  }

  static build = (data: IFilter) => new Filter(data);
  static blank = () => new Filter({ isActive: true });

  /**
   * Constructor
   * @param {IFilter} data
   */
  constructor(data?: IFilter) {
    super(DocType.of('__datum.filter'), data);

    this.name = data?.name || '';
    // TODO: data?.type is legacy data structure
    this.type = FilterType.of(data?.type?.name || data?.type);
    this.items = compact(
      reject(
        map(data?.items, (obj) => new FilterItem(obj)),
        (i) => isEmpty(i.path) || isEmpty(i.values)
      )
    );
    this.isEnterprise = data?.isEnterprise === true;
    this.isShared = data?.isShared === true;
  }
}
